import MapBox from './map'
import * as turf from '@turf/turf'
import { FIR_LAYERS_FEATURE_COLLECTION } from '../data/fir-layers'
import { FIR_DETAILS } from '../data/fir-details'
import { sortBy } from 'lodash'
import AeroSpace from './aerospace'
import AvsecAlerts from './avsecAlerts'
import { ISO_3166_MAPPER } from '../data/ISO_3166_MAPPER'
import { getStandarizedCoordinates } from '../services/MapService'

export class RoutesModule {
    countriesWeaponaryData = []

    isValidRouteCoordinate(decodeRouteResult) {
        return (decodeRouteResult.type === 'Airport' || decodeRouteResult.type === 'Waypoint' || decodeRouteResult.type === 'Composite' || decodeRouteResult.type === 'Custom coordinates' || decodeRouteResult.type === 'NAVAID (VHF)' || decodeRouteResult.type === 'NAVAID (NDB)') && (!!decodeRouteResult.data.longitude && !!decodeRouteResult.data.latitude)
    }

    getRoutesFutureMultiLineString(routes) {
        const feature = {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'MultiLineString',
                coordinates: []
            }
        }

        routes.forEach(route => {
            const validRouteResults = route.decodeRouteResult.filter(routeResult => this.isValidRouteCoordinate(routeResult))
            const validCoordinates = validRouteResults.map(result => [result.data.longitude, result.data.latitude])
            const arrayOfCoordinates = getStandarizedCoordinates(validCoordinates)
            feature.geometry.coordinates.push(arrayOfCoordinates)
        })
                
        return feature
    }

    getRoutesGreatCircleFutureMultiLineString(routes) {
        let greatCircleFeature = null
        routes.forEach(route => {
            greatCircleFeature = turf.greatCircle(
                [route.decodeRouteResult[0].longitude, route.decodeRouteResult[0].latitude], 
                [route.decodeRouteResult[route.decodeRouteResult.length - 1].longitude, route.decodeRouteResult[route.decodeRouteResult.length - 1].latitude], 
                { properties: { name: 'Testing' }}
            )
        })
                
        return greatCircleFeature
    }

    display(routesFeatureMultiLineString) {
        if (routesFeatureMultiLineString.geometry.coordinates.length > 0) {
            MapBox.map.addSource('routes-waypoints', {
                'type': 'geojson',
                'lineMetrics': true,
                'data': routesFeatureMultiLineString 
            })

            MapBox.map.addLayer({
                'id': 'routes-waypoints',
                'type': 'line',
                'source': 'routes-waypoints',
                'layout': {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                'paint': {
                    'line-color': '#0085FF',
                    'line-width': 2,
                    'line-gradient': [
                        'interpolate',
                        ['linear'],
                        ['line-progress'],
                        0, 'rgba(0, 133, 255, 0.2)',
                        0.2, 'rgba(0, 133, 255, 1)',
                        0.55, 'rgba(0, 133, 255, 0.2)',
                        0.7, 'rgba(0, 133, 255, 1)',
                        1, 'rgba(0, 133, 255, 0.2)'
                    ]
                }
            })
        }
    }

    getGeoCodesFeatureCollection(routes) {
        const featureCollection = {
            type: 'FeatureCollection',
            features: []
        }

        routes.forEach(route => {
            route.decodeRouteResult.forEach(routeResult => {
                if (this.isValidRouteCoordinate(routeResult)) {
                    const properties = {
                        ['latitude']: routeResult.latitude,
                        ['longitude']: routeResult.longitude,
                        ['type']: routeResult.type,
                    }
                    
                    const point = {
                        type: 'Point',
                        coordinates: [routeResult.data.longitude, routeResult.data.latitude]
                    }
                    
                    const feature = {
                        type: 'Feature',
                        id: route.routePlanString,
                        geometry: point,
                        properties: properties
                    }
                    
                    featureCollection.features.push(feature)
                }
            })
        })
        
        return featureCollection
    }

    updateDisplay(routes) {
        const routesWaypointsSource = MapBox.map.getSource('routes-waypoints')
        const routesGeoCoordinatesSource = MapBox.map.getSource('routes-geo-coordinates')
        // const routesGreatCircleSource = MapBox.map.getSource('routes-great-circle')
        const routesFeatureMultiLineString = this.getRoutesFutureMultiLineString(routes)
        // const routesGreatCircleFeatureMultiLineString = this.getRoutesGreatCircleFutureMultiLineString(routes)
        const routesFeatureCollectionGeoPoints = this.getGeoCodesFeatureCollection(routes)
        // console.log('routesGreatCircleFeatureMultiLineString', routesGreatCircleFeatureMultiLineString)

        if (routesWaypointsSource === undefined) {
            this.display(routesFeatureMultiLineString)
        } else {
            routesWaypointsSource.setData(routesFeatureMultiLineString)
        }

        if (routesGeoCoordinatesSource !== undefined) {
            routesGeoCoordinatesSource.setData(routesFeatureCollectionGeoPoints)
        } else {
            // Temporary layer of symbols with lat and lng to help debugging 180th meridian line issue
            MapBox.map.addSource('routes-geo-coordinates', {
                'type': 'geojson',
                'data': routesFeatureCollectionGeoPoints
            })

            MapBox.map.addLayer({
                id: 'routes-geo-coordinates-layer',
                type: 'circle',
                source: 'routes-geo-coordinates',
                paint: {
                    'circle-color': '#0182fa',
                    'circle-radius': 4
                }
            })

            MapBox.map.on('mouseenter', 'routes-geo-coordinates-layer', (e) => {
                console.log(e.features[0].properties)
            })
        }

        // if (routesGreatCircleSource !== undefined) {
        //     routesGreatCircleSource.setData(routesGreatCircleFeatureMultiLineString)
        // } else {
        //     // Temporary layer of symbols with lat and lng to help debugging 180th meridian line issue
        //     MapBox.map.addSource('routes-great-circle', {
        //         'type': 'geojson',
        //         'lineMetrics': true,
        //         'data': routesGreatCircleFeatureMultiLineString
        //     })

        //     MapBox.map.addLayer({
        //         id: 'routes-great-circle-layer',
        //         type: 'circle',
        //         source: 'routes-great-circle',
        //         paint: {
        //             'circle-color': '#00FF66',
        //             'circle-radius': 4
        //         }
        //     })
            
        //     MapBox.map.addLayer({
        //         'id': 'routes-great-circle-layer',
        //         'type': 'line',
        //         'source': 'routes-great-circle',
        //         'layout': {
        //             'line-join': 'round',
        //             'line-cap': 'round'
        //         },
        //         'paint': {
        //             'line-color': '#00FF66',
        //             'line-width': 2,
        //             'line-gradient': [
        //                 'interpolate',
        //                 ['linear'],
        //                 ['line-progress'],
        //                 0, 'rgba(0, 255, 102, 0.2)',
        //                 0.2, 'rgba(0, 255, 102, 1)',
        //                 0.55, 'rgba(0, 255, 102, 0.2)',
        //                 0.7, 'rgba(0, 255, 102, 1)',
        //                 1, 'rgba(0, 255, 102, 0.2)'
        //             ]
        //         }
        //     })
        // }
    }

    // Function to generate new coordinates array
    // This function takes an array of geographical coordinates as input, loops through each coordinate, and calculates two new coordinates 
    // at a distance of 10km before and after the original coordinate
    // If the current point is the last one in the array, it calculates the bearing between the previous point and the current point. 
    // It then uses the calculated bearing to generate new coordinates 10km before and after the original point.
    generateNewCoordinates(coordinates) {
        const newCoordinates = []
    
        coordinates.forEach((coord, index) => {
            const point = turf.point(coord)
    
            // Calculate the bearing between current point and the next point in the original array
            const bearing = index < coordinates.length - 1
                ? turf.bearing(point, turf.point(coordinates[index + 1]))
                : turf.bearing(turf.point(coordinates[index - 1]), point)

            // Get the distance between the current point and the next point in the original array
            const distance = index < coordinates.length - 1
                ? turf.distance(point, turf.point(coordinates[index + 1]))
                : turf.distance(turf.point(coordinates[index - 1]), point)

            // If the distance is greater than 300 km, then add points every 100 km
            if (distance > 300) {
                const numberOfPoints = Math.floor(distance / 100)
                const distanceBetweenPoints = distance / numberOfPoints
                for (let i = 0; i < numberOfPoints; i++) {
                    const newPoint = turf.destination(point, distanceBetweenPoints * i, bearing)
                    newCoordinates.push(newPoint.geometry.coordinates)
                }
            } else {
                // Calculate the new point 10km before the original point
                const pointBefore = turf.destination(point, 10, bearing - 180)
                newCoordinates.push(pointBefore.geometry.coordinates)
            
                // Add the original coordinate
                newCoordinates.push(coord)
        
                // Calculate the new point 10km after the original point
                const pointAfter = turf.destination(point, 10, bearing)
                newCoordinates.push(pointAfter.geometry.coordinates)
            }
        })
    
        return newCoordinates
    }

    // Given an array of Line String geo coordinates, return an array of all FIR crossed by that line string
    getRouteCrossedFIRs(lineStringCoordinates) {
        const startTime = performance.now()

        // Given a line string we are going to create an array of original coordinates + additional coordinates that
        // are N km before and after each original coordinate, this will work as all routes are usually when FIR layers are crossed 
        // After that we are going to trigger FIR layers and "ask" for what layer can be found at each point and create unique array
        const pointsAlongTheLine = this.generateNewCoordinates(lineStringCoordinates)

        // Once we have all points we will loop each FIR polygon and ask if any of route points is withing it
        // https://turfjs.org/docs/#pointsWithinPolygon
        const points = turf.points(pointsAlongTheLine)
        let FIRsCrossed = []
        FIR_LAYERS_FEATURE_COLLECTION.features.forEach(FIRFeaturePolygon => {
            const pointsWithin = turf.pointsWithinPolygon(points, FIRFeaturePolygon)

            if (pointsWithin.features.length > 0 && FIRFeaturePolygon.properties.ICAOCODE !== null) {
                // In addition to the FIR properties, we are also going to return the ordering indicator, so we can understand
                // in what order they were crossed
                const firstPointWithin = pointsWithin.features[0]

                FIRsCrossed.push({
                    ...FIRFeaturePolygon.properties,
                    // The ordering is determinated by the first point found crossed in the found FIR
                    ordering: pointsAlongTheLine.findIndex(point => 
                        point[0] === firstPointWithin.geometry.coordinates[0] && point[1] === firstPointWithin.geometry.coordinates[1])
                })
            }
        })

        FIRsCrossed = sortBy(FIRsCrossed, ['ordering'])
        
        const executionTime = performance.now() - startTime
        if (executionTime > 250) {
            console.warn(`The calculation of the route crossing FIR layers took ${executionTime} milliseconds`)
        }

        return FIRsCrossed
    }

    async getRouteInformation(decodeRouteResult) {
        return await new Promise((resolve, reject) => {
            // TODO: there can be a case where a route can have "Tech stops" which are airports, as for now we don't have an example
            // of such a route, so we are not able to get this information for our Routes module. Hopefully, we will get one.
            const lineStringCoordinates = []
            decodeRouteResult.forEach(routeResult => {
                if (this.isValidRouteCoordinate(routeResult)) {
                    lineStringCoordinates.push([routeResult.data.longitude, routeResult.data.latitude])
                }
            })
            const crossedFIRs = this.getRouteCrossedFIRs(lineStringCoordinates)

            // We don't need to use alerts alerts directly, but we still wait for the promise to resolve
            // so we know we can securly call Aviation alerts `getCountryAvsecAlerts` function
            const promises = [AeroSpace.getModuleWarningsAndRestrictions(), AvsecAlerts.getModuleLatestAlerts()]
            Promise.all(promises).then(values => {
                const warningsAndRestrictions = values[0]

                let routeInformation = []
    
                // Now that we have the list of crossed FIRs, lets find out which countries each FIR layer belongs to
                // We need that information to understand association to Aviation Alerts, so:
                // We know FIR > we figure out the country > Aviation alerts are issued against countries (hopefully will be improved/more precise in future)
                // > we associated the alerts against that FIR layer
                routeInformation = crossedFIRs.map(FIR => {
                    let affectedFIRs = warningsAndRestrictions.filter(restriction => restriction.affectedFIRs.indexOf(FIR.ICAOCODE) > -1)
                    let highestFlightRestrictionLevel = 0
                    affectedFIRs.forEach(affectedFIR => {
                        if (affectedFIR.flightLevel > highestFlightRestrictionLevel) highestFlightRestrictionLevel = affectedFIR.flightLevel
                    })

                    let highestWeaponaryMaxEffectiveAltitude = 0
                    let countryWeaponaryData = this.findCountryWeaponaryData(FIR_DETAILS[FIR.ICAOCODE].controllingCountryCode)
                    if (countryWeaponaryData === undefined) {
                        countryWeaponaryData = {}
                    } else {
                        countryWeaponaryData.Value.CountryThreatTypes.forEach(threatType => {
                            if (threatType.MaxEffectiveAltitude > highestWeaponaryMaxEffectiveAltitude)
                                highestWeaponaryMaxEffectiveAltitude = threatType.MaxEffectiveAltitude
                        })
                    }

                    return {
                        type: 'FIR', // Could be also an airport, see comment above
                        details: {
                            id: FIR.OBJECTID,
                            icao: FIR.ICAOCODE,
                            name: FIR.NOM_COMP,
                            region: FIR.REGION,
                            country: FIR.Country_So,
                            countries: FIR_DETAILS[FIR.ICAOCODE].countries,
                            ISO_3166_1_ALPHA_3: FIR_DETAILS[FIR.ICAOCODE].controllingCountryCode,
                            flightRestrictions: affectedFIRs,
                            countryWeaponaryData: countryWeaponaryData,
                            highestWeaponaryMaxEffectiveAltitude: highestWeaponaryMaxEffectiveAltitude,
                            highestFlightRestrictionLevel: highestFlightRestrictionLevel,
                            aviationAlerts: AvsecAlerts.getCountryAvsecAlerts(ISO_3166_MAPPER[FIR_DETAILS[FIR.ICAOCODE].controllingCountryCode])
                        }
                    }
                })
                
                resolve(routeInformation)   
            })
            
        })      
    }

    findCountryWeaponaryData(countryISO) {
        return this.countriesWeaponaryData.find(country => {
            return country.CountryCodeAlpha3 === countryISO
        })
    }
    
    show() {
        MapBox.map.setLayoutProperty('routes-waypoints', 'visibility', 'visible')
        MapBox.map.setLayoutProperty('routes-geo-coordinates-layer', 'visibility', 'visible')
    }

    hide() {
        MapBox.map.setLayoutProperty('routes-waypoints', 'visibility', 'none')
        MapBox.map.setLayoutProperty('routes-geo-coordinates-layer', 'visibility', 'none')
    }
}

const Routes = new RoutesModule()
export default Routes